import {
  COUPON_CATEGORY_LABELS,
  COUPON_STATUS,
  COUPON_STATUS_LABELS,
  DISCOUNT_TYPES,
} from "constants/coupons";

import { normalizeDate } from "./dateUtils";

export const resolveCouponStatus = (
  effectiveDate,
  expiryDate,
  now = new Date()
) => {
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);

  const effective = normalizeDate(effectiveDate);
  const expiry = normalizeDate(expiryDate);

  if (effective && today < effective) {
    return COUPON_STATUS.SCHEDULED;
  }

  if (expiry && today > expiry) {
    return COUPON_STATUS.EXPIRED;
  }

  return COUPON_STATUS.ACTIVE;
};

export const getCouponStatusLabel = (status) =>
  COUPON_STATUS_LABELS[status] ?? status;

export const getCouponCategoryLabel = (category) => {
  const trimmed = category?.trim();
  if (!trimmed) return "—";
  return COUPON_CATEGORY_LABELS[trimmed] ?? trimmed;
};

export const mapCouponToFormValues = (coupon) => ({
  ...coupon,
  platforms: coupon.platforms ?? [],
  remarks: coupon.remarks ?? coupon.description ?? "",
  totalCouponCount: coupon.totalCouponCount ?? coupon.totalUsageLimit ?? "",
  minimumPackageMrp: coupon.minimumPackageMrp ?? 0,
  minimumCartMrp: coupon.minimumCartMrp ?? coupon.minCartValue ?? "",
  maxAllowedAmount: coupon.maxAllowedAmount ?? coupon.maxDiscount ?? "",
  isApplicableMultipleTimes: coupon.isApplicableMultipleTimes ?? true,
  isApplicableForSingleUser: coupon.isApplicableForSingleUser ?? false,
  uamId: coupon.uamId ?? "",
  selectAllPackages: coupon.selectAllPackages ?? true,
  packageIds: coupon.packageIds ?? [],
  selectAllPlatforms: coupon.selectAllPlatforms ?? true,
  platformIds: coupon.platformIds ?? [],
});

export const formatCouponDiscount = (coupon) => {
  if (coupon.discountType === DISCOUNT_TYPES.PERCENTAGE) {
    return `${coupon.discountValue}%`;
  }

  return `₹${coupon.discountValue}`;
};

export const formatCouponDate = (dateStr) => {
  if (!dateStr) return "-";

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatCouponDateRange = (start, end) =>
  `${formatCouponDate(start)} – ${formatCouponDate(end)}`;

export const formatUsageLimit = (coupon) => {
  const used = coupon.usedCount ?? 0;
  const total = coupon.totalUsageLimit ?? 0;
  return `${used} / ${total}`;
};

export const formatCouponCategory = (category) =>
  getCouponCategoryLabel(category);
